<template>
  <div class="detail-container">
    <!-- Hero Section with Cover Image -->
    <div class="hero-section" :style="{ backgroundImage: `url(${gameData.cover})` }">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="hero-info">
          <div class="game-badges">
            <span v-if="gameData.download_type === 'vip'" class="badge-vip">
              <i class="el-icon-medal"></i> VIP专享
            </span>
            <span v-else class="badge-free">
              <i class="el-icon-check"></i> 免费
            </span>
            <span class="badge-category">{{ getCategoryLabel(gameData.category) }}</span>
          </div>
          <h1 class="game-title">{{ gameData.title }}</h1>
          <div class="game-meta">
            <span class="meta-item">
              <i class="el-icon-time"></i>
              {{ getTheTime(gameData.game_update_time) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <div class="content-wrapper">
        <!-- Left Column: Game Info -->
        <div class="left-column">
          <!-- Description Card -->
          <div class="info-card">
            <h2 class="card-title">
              <i class="el-icon-document"></i>
              游戏介绍
            </h2>
            <div class="description" v-html="gameData.content"></div>
          </div>

          <!-- Screenshots Gallery -->
          <div class="info-card" v-if="gameData.contentImages && gameData.contentImages.length">
            <h2 class="card-title">
              <i class="el-icon-picture"></i>
              游戏截图
            </h2>
            <div class="screenshots-grid">
              <div
                v-for="(image, index) in gameData.contentImages"
                :key="index"
                class="screenshot-item"
              >
                <el-image
                  :src="proxyImage(image)"
                  fit="cover"
                  class="screenshot-image"
                  :preview-src-list="gameData.contentImages.map((img) => proxyImage(img))"
                >
                </el-image>
              </div>
            </div>
          </div>

          <!-- Disclaimer -->
          <div class="info-card disclaimer-card">
            <h2 class="card-title">
              <i class="el-icon-warning"></i>
              网站声明
            </h2>
            <div class="disclaimer-content">
              <p>本站发布的游戏资源如有侵犯你的合法权益请联系管理员下架 2HVR网站，站内资源为网友个人行为上传学习或测试研究使用，未经原版权作者许可，禁止用于任何商业途径！</p>
              <p>本站资源来自网络，版权争议与本站无关。您必须在下载后的24个小时之内，从您的电脑或其他设备中彻底删除上述内容，用户所表达的"不代表本站立场"，所造成的后果与本站无关！</p>
              <p>本站为非盈利性站点，VIP功能仅仅作为用户喜欢本站捐赠打赏功能和人工技术解答服务，所有内容不作为商业行为。如果侵权请联系：2hvr@2hvr.me 我们下架。</p>
            </div>
          </div>
        </div>

        <!-- Right Column: Download Section (Sticky) -->
        <div class="right-column">
          <div class="download-sticky">
            <div class="download-card-new">
              <div class="download-header">
                <i class="el-icon-download"></i>
                <span>下载游戏</span>
              </div>
              <div class="download-body">
                <div class="download-type">
                  <span v-if="gameData.download_type === 'free'" class="type-free">
                    <i class="el-icon-check"></i> 免费下载
                  </span>
                  <span v-else class="type-vip">
                    <i class="el-icon-medal"></i> VIP专享
                  </span>
                </div>
                <button 
                  class="download-btn-new"
                  :class="{ 'btn-vip': gameData.download_type !== 'free' }"
                  @click="handleDownload"
                >
                  <i class="el-icon-download"></i>
                  <span>{{ gameData.download_type === "free" ? "立即下载" : "会员下载" }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="showDownloadDialog"
      title="下载资源"
      width="480px"
      class="download-dialog-v2"
      :close-on-click-modal="false"
    >
      <div v-if="isDownload" class="dl-content">
        <!-- 顶部统计栏 -->
        <div class="dl-stats-bar">
          <div class="dl-stat-item">
            <span class="dl-stat-num" :class="{ 'is-unlimited': downloadInfo.remainingDownloads === '无限次' }">{{ downloadInfo.remainingDownloads }}</span>
            <span class="dl-stat-label">剩余</span>
          </div>
          <div class="dl-stat-divider"></div>
          <div class="dl-stat-item">
            <span class="dl-stat-num">{{ downloadInfo.totalDownloads }}</span>
            <span class="dl-stat-label">已下载</span>
          </div>
          <div class="dl-stat-divider"></div>
          <div class="dl-stat-item">
            <span class="dl-stat-num" :class="{ 'is-unlimited': downloadInfo.totalLimit === '无限次' }">{{ downloadInfo.totalLimit }}</span>
            <span class="dl-stat-label">总限制</span>
          </div>
          <div class="dl-stat-tip">
            <i class="el-icon-time"></i> 24h内重复免费
          </div>
        </div>

        <div class="dl-moqu-limit-tip" v-if="isPremiumUser && moquDirectDailyLimit.limit > 0">
          <i class="el-icon-connection"></i>
          魔趣直连今日额度：{{ moquDirectDailyLimit.used }}/{{ moquDirectDailyLimit.limit }}（剩余 {{ moquDirectDailyLimit.remaining }}）
        </div>

        <!-- 全能卡专属区域 -->
        <div class="dl-premium-banner" v-if="(tianyiOptions.length > 0 || pan123Options.length > 0 || moquDirectVersions.length > 0) && !isPremiumUser">
          <i class="el-icon-star-on"></i>
          <span>全能卡会员专享</span>
        </div>

        <!-- 高速直连（推荐） -->
        <div class="dl-section dl-tianyi" v-if="tianyiOptions.length > 0">
          <div class="dl-section-title">
            <i class="el-icon-position"></i> 高速直连
            <el-tag size="mini" effect="dark" type="success">推荐</el-tag>
          </div>
          <div class="dl-btn-list">
            <el-button
              v-for="option in tianyiOptions"
              :key="'tianyi-' + option.index"
              :type="option.locked ? 'info' : 'success'"
              size="medium"
              class="dl-btn"
              :class="{ 'is-locked': option.locked }"
              :disabled="downloadingOption === option"
              :loading="downloadingOption === option"
              @click="handleActualDownload(option)"
            >
              <i :class="option.locked ? 'el-icon-lock' : 'el-icon-download'"></i>
              {{ option.name }}
              <span class="dl-btn-tag" v-if="option.freeDownload">免费</span>
            </el-button>
          </div>
        </div>

        <!-- 直链下载（全能卡专享）- 按版本分组显示 -->
        <div class="dl-section dl-moqu-direct" v-if="moquDirectVersions.length > 0">
          <div class="dl-section-title">
            <i class="el-icon-connection"></i> 直链下载
            <el-tag size="mini" effect="dark" type="warning">全能卡</el-tag>
          </div>
          <!-- 按版本分组 -->
          <div 
            v-for="(version, vIdx) in moquDirectVersions" 
            :key="'moqu-version-' + vIdx"
            class="dl-version-group"
          >
            <div class="dl-version-title" v-if="moquDirectVersions.length > 1">
              {{ version.versionName }}
            </div>
            <div class="dl-btn-list">
              <el-button
                v-for="btn in version.buttons"
                :key="'moqu-direct-' + btn.index"
                :type="btn.locked ? 'info' : 'warning'"
                size="medium"
                class="dl-btn"
                :class="{ 'is-locked': btn.locked }"
                :disabled="downloadingOption === btn"
                :loading="downloadingOption === btn"
                @click="handleActualDownload(btn)"
              >
                <i :class="btn.locked ? 'el-icon-lock' : 'el-icon-download'"></i>
                {{ btn.name }}
                <span class="dl-btn-tag" v-if="btn.freeDownload">免费</span>
              </el-button>
            </div>
          </div>
        </div>

        <!-- 全能专属直连 - 暂时注释 -->
        <!-- <div class="dl-section dl-pan123" v-if="pan123Options.length > 0">
          <div class="dl-section-title">
            <i class="el-icon-connection"></i> 专属直连
          </div>
          <div class="dl-btn-list">
            <el-button
              v-for="option in pan123Options"
              :key="'pan123-' + option.index"
              :type="option.locked ? 'info' : 'warning'"
              size="medium"
              class="dl-btn"
              :class="{ 'is-locked': option.locked }"
              :disabled="downloadingOption === option"
              :loading="downloadingOption === option"
              @click="handleActualDownload(option)"
            >
              <i :class="option.locked ? 'el-icon-lock' : 'el-icon-download'"></i>
              {{ option.name }}
              <span class="dl-btn-tag" v-if="option.freeDownload">免费</span>
            </el-button>
          </div>
        </div> -->

        <!-- 网盘下载 -->
        <div class="dl-section dl-cloud" v-if="cloudOptions.length > 0">
          <div class="dl-section-title">
            <i class="el-icon-folder-opened"></i> 网盘下载
          </div>
          <div class="dl-btn-list dl-btn-row">
            <el-button
              v-for="option in cloudOptions"
              :key="'cloud-' + option.index"
              type="primary"
              size="medium"
              class="dl-btn"
              :disabled="downloadingOption === option"
              :loading="downloadingOption === option"
              @click="handleActualDownload(option)"
            >
              <i class="el-icon-download"></i>
              {{ option.name }}
              <span class="dl-btn-tag" v-if="option.freeDownload">免费</span>
            </el-button>
          </div>
        </div>

        <!-- 无网盘下载选项提示 -->
        <div class="dl-empty dl-empty-cloud" v-if="cloudOptions.length === 0 && moquDirectVersions.length > 0">
          <i class="el-icon-info"></i>
          <span>暂无网盘链接，请使用上方直连下载</span>
        </div>

        <!-- 完全无下载选项 -->
        <div class="dl-empty" v-if="newDownloadOptions.length === 0 && moquDirectVersions.length === 0">
          <i class="el-icon-warning-outline"></i>
          <span>暂无可用下载链接</span>
        </div>

        <!-- 申请直连按钮 - 已移除，使用魔趣直连替代 -->
        
        <!-- 密码提示（折叠式） -->
        <div class="dl-password">
          <div class="dl-pwd-row">
            <span class="dl-pwd-label">解压密码</span>
            <code class="dl-pwd-value" @click="copyToClipboard('vrmoo.cn')">vrmoo.cn</code>
            <span class="dl-pwd-label">资源密码</span>
            <code class="dl-pwd-value" @click="copyToClipboard('vrmo')">vrmo</code>
          </div>
        </div>
      </div>

      <!-- 暂无资源状态 -->
      <div v-else-if="noResourceAvailable" class="dl-no-resource">
        <div class="dl-empty-box">
          <i class="el-icon-folder-remove"></i>
          <div class="dl-empty-text">
            <h4>暂无下载资源</h4>
            <p>该游戏暂无可用下载链接</p>
          </div>
        </div>
      </div>

      <!-- 无权限状态 -->
      <div v-else class="dl-no-permission">
        <div class="dl-vip-box">
          <i class="el-icon-warning-outline"></i>
          <div class="dl-vip-text">
            <h4>{{ permissionAlert.title }}</h4>
            <p>开通VIP畅享无限下载特权</p>
          </div>
        </div>
        <el-button type="danger" class="dl-upgrade-btn" @click="handleUpgrade">
          <i class="el-icon-shopping-cart-full"></i> 立即开通VIP
        </el-button>
      </div>
    </el-dialog>

    <!-- 直连下载列表弹窗 -->
    <el-dialog
      :visible.sync="showDirectDownloadDialog"
      title="直连下载列表"
      width="800px"
      class="direct-download-dialog"
      custom-class="custom-dialog"
    >
      <div class="direct-download-content">
        <!-- 列表头部信息 -->
        <div class="download-list-header">
          <div class="header-info">
            <i class="el-icon-folder-opened"></i>
            <span>共 {{ directDownloadList.length }} 个文件</span>
          </div>
          <!-- <div class="share-code-info" v-if="shareCode">
            <span class="share-label">分享码:</span>
            <span class="share-code">{{ shareCode }}</span>
          </div> -->
        </div>

        <!-- 文件列表 -->
        <div class="file-list">
          <div 
            v-for="(file, index) in directDownloadList" 
            :key="file.FileId"
            class="file-item"
          >
            <div class="file-info">
              <div class="file-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="file-details">
                <div class="file-name" :title="file.FileName">{{ file.FileName }}</div>
                <div class="file-meta">
                  <span class="file-size">{{ formatFileSize(file.Size) }}</span>
                  <span class="file-id">ID: {{ file.FileId }}</span>
                </div>
              </div>
            </div>
            <div class="file-actions">
              <el-button 
                type="primary" 
                size="small"
                @click="handleDirectDownload(file.FileId,file)"
                class="download-btn-small"
              >
                <i class="el-icon-download"></i>
                下载
              </el-button>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="directDownloadList.length === 0" class="empty-state">
          <i class="el-icon-folder-remove"></i>
          <p>暂无可下载文件</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMqInfo, getMqDirectDownloadList, getRealDownloadUrl, createDownloadToken, getDownloadOptions, getActualDownloadLink, requestTianyiDirect } from "@/api";
import { formatTimeAgo } from "@/utils";
export default {
  data() {
    return {
      id: null,
      gameData: {
        title: "",
        download_type: "",
        created_at: "",
        cover: "",
        content: "",
        contentImages: [],
      },
      showDownloadDialog: false,
      isDownload: false,
      // 新版下载选项（两步流程）
      newDownloadOptions: [], // 从 download-options 接口获取
      moquDirectVersions: [], // 魔趣直连按版本分组
      downloadInfo: {
        remainingDownloads: "无限次",
        totalDownloads: 0,
        totalLimit: "无限次"
      },
      moquDirectDailyLimit: {
        limit: 0,
        used: 0,
        remaining: 0
      },
      isPremiumUser: false, // 是否为全能卡会员
      vipType: 'basic', // 会员类型
      permissionAlert: {
        title: "今日下载次数已达上限/本月VIP已过期",
        type: "warning",
      },
      // 直连下载列表相关数据
      showDirectDownloadDialog: false,
      directDownloadList: [],
      shareCode: '',
      currentCloudIndex: 0, // 当前选择的网盘索引
      // 下载中状态
      downloadingOption: null,
      // 申请直连相关
      requestingTianyi: false,
      hastianyiResource: false // 是否已有天翼云资源
    };
  },
  computed: {
    // 网盘下载选项
    cloudOptions() {
      return this.newDownloadOptions.filter(opt => opt.type === 'cloud');
    },
    // 天翼直连选项
    tianyiOptions() {
      return this.newDownloadOptions.filter(opt => opt.type === 'tianyi');
    },
    // 123网盘直连选项（全能卡专享）
    pan123Options() {
      return this.newDownloadOptions.filter(opt => opt.type === '123pan');
    },
    // 判断是否为"无资源"状态（区别于"无权限"）
    noResourceAvailable() {
      return this.newDownloadOptions.length === 0 && this.moquDirectVersions.length === 0 && !this.hastianyiResource;
    }
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.fetchGameData();
  },
  methods: {
    // ========== 新版两步下载流程 ==========
    
    // 第一步：点击"会员下载"按钮，获取下载选项（不扣费）
    handleDownload() {
      getDownloadOptions(this.id)
        .then((res) => {
          console.log('下载选项:', res);
          this.newDownloadOptions = res.data.options || [];
          this.moquDirectVersions = res.data.moquDirectVersions || [];
          this.isPremiumUser = res.data.isPremiumUser || false;
          this.vipType = res.data.vipType || 'basic';
          this.hastianyiResource = res.data.hastianyiResource || false;
          
          // 处理下载次数信息
          if (res.data.remainingDownloads !== undefined) {
            this.downloadInfo.remainingDownloads = res.data.remainingDownloads;
          }
          if (res.data.totalDownloads !== undefined) {
            this.downloadInfo.totalDownloads = res.data.totalDownloads;
          }
          if (res.data.totalLimit !== undefined) {
            this.downloadInfo.totalLimit = res.data.totalLimit;
          }

          // 魔趣直连每日额度（全能卡）
          if (res.data.moquDirectDailyLimit) {
            this.moquDirectDailyLimit = {
              limit: res.data.moquDirectDailyLimit.limit || 0,
              used: res.data.moquDirectDailyLimit.used || 0,
              remaining: res.data.moquDirectDailyLimit.remaining || 0
            }
          } else {
            this.moquDirectDailyLimit = {
              limit: 0,
              used: 0,
              remaining: 0
            }
          }
          
          this.showDownloadDialog = true;
          this.isDownload = res.data.hasOptions;
        })
        .catch((err) => {
          console.log(err);
          this.isDownload = false;
          this.showDownloadDialog = true;
        });
    },
    
    // 第二步：点击具体下载按钮，获取真实链接（扣费）
    async handleActualDownload(option) {
      if (this.downloadingOption) {
        return; // 防止重复点击
      }
      
      // 检查是否锁定（非全能卡用户点击直连下载）
      if (option.locked) {
        this.$message.warning(option.lockReason || '直连下载需要全能卡会员，请升级会员');
        return;
      }
      
      this.downloadingOption = option;
      
      try {
        const res = await getActualDownloadLink(this.id, {
          type: option.type,
          index: option.index
        });
        
        console.log('获取真实下载链接:', res);
        
        if (res.code === 200 && res.data) {
          // 显示是否为免费下载（24小时内重复）
          if (res.data.isFreeDownload) {
            this.$message.success('24小时内已下载过，本次不扣费');
          }
          
          if (option.type === 'moqu_direct' && res.data.moquDirectDailyLimit) {
            this.moquDirectDailyLimit = {
              limit: res.data.moquDirectDailyLimit.limit || 0,
              used: res.data.moquDirectDailyLimit.used || 0,
              remaining: res.data.moquDirectDailyLimit.remaining || 0
            }
          }

          if (option.type === 'tianyi') {
            // 天翼直连：直接打开下载链接
            if (res.data.downloadUrl) {
              window.open(res.data.downloadUrl, '_blank');
            } else {
              this.$message.error('下载链接不可用');
            }
          } else if (option.type === 'moqu_direct') {
            // 魔趣直连（全能卡专享）：直接打开下载链接
            if (res.data.downloadUrl) {
              window.open(res.data.downloadUrl, '_blank');
            } else {
              this.$message.error('下载链接不可用');
            }
          } else if (option.type === '123pan') {
            // 123网盘直连（全能卡专享）：需要获取文件列表
            if (res.data.needFetchFiles) {
              const downlinksIndex = res.data.downlinksIndex !== undefined ? res.data.downlinksIndex : option.index;
              this.currentCloudIndex = downlinksIndex;
              this.getCloudFileList(downlinksIndex);
            } else {
              this.$message.error('获取文件列表失败');
            }
          } else if (option.type === 'cloud') {
            // 网盘下载：直接跳转
            if (res.data.linkUrl) {
              window.open(res.data.linkUrl, '_blank');
            } else {
              this.$message.error('下载链接不可用');
            }
          }
        } else {
          this.$message.error(res.message || '获取下载链接失败');
        }
      } catch (err) {
        console.error('获取下载链接失败:', err);
        this.$message.error(err.response?.data?.message || '获取下载链接失败');
      } finally {
        this.downloadingOption = null;
      }
    },
    
    // 获取网盘文件列表
    getCloudFileList(index) {
      getMqDirectDownloadList(this.id, { index })
        .then((res) => {
          console.log('网盘文件列表:', res);
          this.directDownloadList = res.data.infoList || [];
          this.shareCode = res.data.shareCode || '';
          this.showDirectDownloadDialog = true;
        })
        .catch((err) => {
          console.error('获取文件列表失败:', err);
          this.$message.error('获取文件列表失败');
        });
    },
    
    // 获取选项显示文本
    getOptionText(option) {
      if (option.freeDownload) {
        return `${option.name} (免费)`;
      }
      return option.name;
    },
    
    // 获取选项按钮类型
    getOptionButtonType(option) {
      if (option.locked) return 'info';
      if (option.type === 'tianyi') return 'success';
      return 'primary';
    },
    fetchGameData() {
      getMqInfo(this.id)
        .then((res) => {
          this.gameData = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleUpgrade() {
      this.$emit("showVipDialog");
    },
    openUrl(url) {
      window.open(url, "_blank");
    },

      // 处理直连下载按钮点击
      handleDirectDownload(fileId, file) {
        console.log('点击直连下载，FileId:', fileId);
        console.log('ShareCode:', this.shareCode);
        console.log('file:', file);
        // this.$message.warning('直连下载维护中，请使用其他方式下载');
        
        // ===== 方式一：直接获取下载URL（已注释，速度快但不占用服务器带宽） =====
        // 如需切换到直接下载方式，请取消下面代码的注释，并注释掉方式二的代码
        const requestData = {
          shareKey: this.shareCode,
          fileId: fileId,
          gameId: this.id,
          file
        };
        getRealDownloadUrl(requestData)
          .then((res) => {
            console.log('获取真实下载地址成功:', res);
            if (res.success && res.code === 200 && res.data) {
              const { downloadUrl } = res.data;
              if (downloadUrl) {
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = file.FileName || 'download';
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                this.$message.error('下载失败，请稍后重试');
              }
            } else {
              this.$message.error('下载失败，请稍后重试');
            }
          })
          .catch((err) => {
            console.error('获取真实下载地址失败:', err);
            this.$message.error('下载失败，请稍后重试');
          });
        
        // ===== 方式二：通过服务器代理下载（当前使用） =====
        // 第一步：创建下载令牌（需要认证）
        // createDownloadToken({
        //   shareKey: this.shareCode,
        //   fileId: fileId,
        //   gameId: this.id,
        //   file: file
        // })
        // .then((res) => {
        //   if (res.code === 200) {
        //     const { token } = res.data;
            
        //     // 第二步：使用令牌跳转下载 (无需认证，Token有效期60秒)
        //     // 直接跳转，浏览器接管下载
        //     window.location.href = `https://download.788vr.com/moquResource/proxyDownload?token=${token}`;
            
        //     this.$message.success('下载已开始，请查看浏览器下载管理器');
        //   } else {
        //     this.$message.error(res.message || '获取下载令牌失败');
        //   }
        // })
        // .catch((err) => {
        //   console.error('创建下载令牌失败:', err);
        //   this.$message.error('下载失败，请稍后重试');
        // });
      },
      // 格式化文件大小
      formatFileSize(size) {
        if (size < 1024) {
          return size + ' B';
        } else if (size < 1024 * 1024) {
          return (size / 1024).toFixed(2) + ' KB';
        } else if (size < 1024 * 1024 * 1024) {
          return (size / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
          return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
        }
      },
      proxyImage(url) {
        // 方案1：使用后端代理
        // return `/api/proxy-image?url=${encodeURIComponent(url)}`;
        return url;
      },
    getCategoryLabel(category) {
      const map = {
        quest: "Quest",
        steamvr: "SteamVR",
        tutorial: "教程",
        other: "其他",
      };
      return map[category] || category;
    },
    getTheTime(time){
      return formatTimeAgo(time);
    },
    
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(`已复制：${text}`);
        }).catch(() => {
          this.fallbackCopyTextToClipboard(text);
        });
      } else {
        this.fallbackCopyTextToClipboard(text);
      }
    },
    
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.$message.success(`已复制：${text}`);
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      
      document.body.removeChild(textArea);
    },

    // 申请天翼云直连
    async requestTianyiDirect() {
      if (this.requestingTianyi) {
        return;
      }

      this.requestingTianyi = true;
      try {
        const res = await requestTianyiDirect(this.id);
        
        if (res.code === 200) {
          this.$message.success(res.data.message || '申请已提交');
          this.showDownloadDialog = false;
        } else {
          this.$message.error(res.message || '申请失败');
        }
      } catch (err) {
        console.error('申请直连失败:', err);
        this.$message.error(err.response?.data?.message || '申请失败，请稍后重试');
      } finally {
        this.requestingTianyi = false;
      }
    },
    
    // 计算下载进度百分比
    getDownloadProgress() {
      if (this.downloadInfo.totalLimit === '无限次' || this.downloadInfo.totalLimit <= 0) {
        return 0;
      }
      const progress = (this.downloadInfo.totalDownloads / this.downloadInfo.totalLimit) * 100;
      return Math.min(progress, 100);
    },
    
    // 获取进度条颜色
    getProgressColor() {
      const progress = this.getDownloadProgress();
      if (progress < 50) {
        return '#67c23a'; // 绿色
      } else if (progress < 80) {
        return '#e6a23c'; // 橙色
      } else {
        return '#f56c6c'; // 红色
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dark-theme.scss";

.detail-container {
  background: $dark;
  min-height: 100vh;
  padding: 0;
}

// Hero Section
.hero-section {
  position: relative;
  height: 500px;
  background-size: cover;
  background-position: center;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 350px;
  }
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, 
    rgba($dark, 0.3) 0%, 
    rgba($dark, 0.7) 50%, 
    $dark 100%
  );
}

.hero-content {
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 32px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 48px;

  @media (max-width: 768px) {
    padding: 0 20px 32px;
  }
}

.hero-info {
  max-width: 800px;
}

.game-badges {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.badge-vip,
.badge-free,
.badge-category {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: $radius-xl;
  font-size: 14px;
  font-weight: 600;
  backdrop-filter: blur(12px);
}

.badge-vip {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
  border: 1px solid rgba(251, 191, 36, 0.5);
}

.badge-free {
  background: rgba(103, 194, 58, 0.2);
  color: #67c23a;
  border: 1px solid rgba(103, 194, 58, 0.5);
}

.badge-category {
  background: rgba(139, 92, 246, 0.2);
  color: $primary;
  border: 1px solid rgba(139, 92, 246, 0.5);
}

.game-title {
  font-size: 48px;
  font-weight: 700;
  color: white;
  margin: 0 0 16px 0;
  line-height: 1.2;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    font-size: 32px;
  }
}

.game-meta {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: $slate-200;
  font-size: 16px;
  
  i {
    font-size: 18px;
  }
}

// Main Content
.main-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 48px 32px;

  @media (max-width: 768px) {
    padding: 32px 20px;
  }
}

.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

// Left Column
.left-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-card {
  @include card-style;
  padding: 32px;

  @media (max-width: 768px) {
    padding: 24px;
  }
}

.card-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin: 0 0 24px 0;

  i {
    color: $primary;
    font-size: 26px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
}

.description {
  color: $slate-300;
  line-height: 1.8;
  font-size: 16px;
  white-space: pre-wrap;

  :deep(p) {
    margin: 16px 0;
  }

  :deep(strong) {
    color: white;
  }
}

// Screenshots
.screenshots-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.screenshot-item {
  position: relative;
  padding-top: 56.25%; // 16:9 aspect ratio
  border-radius: $radius-md;
  overflow: hidden;
  cursor: pointer;
  transition: $transition-normal;

  &:hover {
    transform: scale(1.02);
  }
}

.screenshot-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// Disclaimer
.disclaimer-card {
  background: rgba(245, 108, 108, 0.05);
  border-color: rgba(245, 108, 108, 0.2);
}

.disclaimer-content {
  p {
    color: $slate-300;
    line-height: 1.8;
    font-size: 14px;
    margin: 12px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

// Right Column - Download Section
.right-column {
  @media (max-width: 1024px) {
    order: -1; // Move to top on mobile
  }
}

.download-sticky {
  position: sticky;
  top: 80px;

  @media (max-width: 1024px) {
    position: relative;
    top: 0;
  }
}

.download-card-new {
  @include card-style;
  overflow: hidden;
  border: 2px solid rgba($primary, 0.3);
  box-shadow: $shadow-primary;
}

.download-header {
  background: $gradient-primary;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
  font-size: 18px;
  font-weight: 700;

  i {
    font-size: 22px;
  }
}

.download-body {
  padding: 24px;
}

.download-type {
  margin-bottom: 20px;
  text-align: center;
}

.type-free,
.type-vip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: $radius-xl;
  font-size: 16px;
  font-weight: 600;
}

.type-free {
  background: rgba(103, 194, 58, 0.15);
  color: #67c23a;
  border: 2px solid rgba(103, 194, 58, 0.3);
}

.type-vip {
  background: rgba(251, 191, 36, 0.15);
  color: #fbbf24;
  border: 2px solid rgba(251, 191, 36, 0.3);
}

.download-btn-new {
  width: 100%;
  height: 56px;
  border: none;
  border-radius: $radius-xl;
  background: $gradient-primary;
  color: white;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: $transition-normal;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: $shadow-md;

  i {
    font-size: 22px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: $shadow-primary;
    opacity: 0.95;
  }

  &:active {
    transform: translateY(0);
  }

  &.btn-vip {
    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    box-shadow: 0 4px 20px rgba(251, 191, 36, 0.4);

    &:hover {
      box-shadow: 0 6px 24px rgba(251, 191, 36, 0.5);
    }
  }
}

/* 弹窗样式优化 */
.custom-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.dialog-content {
  padding: 20px;
}

/* 紧凑的下载统计信息样式 */
.download-stats-compact {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.stat-card {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 32px;
  height: 32px;
  background: #e6f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.stat-icon i {
  color: #409eff;
  font-size: 16px;
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
  margin-bottom: 2px;
}

.stat-value.unlimited {
  color: #67c23a;
}

.stat-label {
  font-size: 12px;
  color: #909399;
  line-height: 1;
}

.progress-section {
  background: white;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.progress-text {
  color: #409eff;
  font-weight: 600;
}

.download-progress {
  margin: 0;
}

/* 紧凑的下载提示 */
.download-tips-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #909399;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 6px;
  border-left: 3px solid #409eff;
}

.download-tips-compact i {
  color: #409eff;
  font-size: 16px;
}

/* 紧凑的下载选项网格 */
.download-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.download-option-compact {
  height: 40px;
  border-radius: 6px;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.download-option-compact:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.option-text {
  flex: 1;
  text-align: center;
}

.option-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #409eff;
  color: white;
  padding: 1px 6px;
  font-size: 10px;
  border-radius: 0 6px 0 6px;
  line-height: 1;
}

/* 紧凑的密码提示 */
.password-tips-compact {
  background: #fdf6ec;
  border-radius: 8px;
  padding: 16px;
  border-left: 3px solid #e6a23c;
}

.password-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #e6a23c;
  font-size: 16px;
}

.password-header i {
  font-size: 18px;
}

.password-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.password-item-compact {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.password-label {
  font-size: 12px;
  color: #909399;
  font-weight: 500;
}

.password-value-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 4px;
  padding: 6px 8px;
  border: 1px solid #e4e7ed;
}

.password-value {
  flex: 1;
  font-family: 'Courier New', monospace;
  color: #e6a23c;
  font-weight: 600;
  font-size: 13px;
}

.copy-btn-compact {
  color: #409eff;
  padding: 2px;
  margin-left: 4px;
}

.copy-btn-compact:hover {
  color: #66b1ff;
}

.password-note-compact {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #909399;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
}

.password-note-compact i {
  color: #e6a23c;
  font-size: 14px;
}

.vip-reminder {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px;
  background: #fdf6ec;
  border-radius: 12px;
  margin-bottom: 24px;
}

.warning-icon {
  font-size: 48px;
  color: #e6a23c;
}

.reminder-text h3 {
  color: #e6a23c;
  margin: 0 0 8px 0;
  font-size: 18px;
}

.reminder-text p {
  color: #606266;
  margin: 0;
  font-size: 14px;
}

.upgrade-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f56c6c 0%, #e6a23c 100%);
  border-color: #f56c6c;
  transition: all 0.3s ease;
}

.upgrade-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
  background: linear-gradient(135deg, #f78989 0%, #e9ab47 100%);
  border-color: #f78989;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .detail-card {
    padding: 20px;
  }

  .title {
    font-size: 20px;
  }

  .main-image {
    height: 250px;
  }

  .content-image {
    height: 200px;
  }

  .download-card {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .download-btn {
    width: 100%;
  }

  .download-options-grid {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .password-grid {
    grid-template-columns: 1fr;
  }

  .vip-reminder {
    flex-direction: column;
    text-align: center;
    padding: 16px;
  }

  .vip-download-grid {
    grid-template-columns: 1fr;
  }
}

/* 天翼云下载区域样式 */
.tianyi-download-section {
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #e6fff2 0%, #d9ffeb 100%);
  border-radius: 12px;
  border: 2px solid #52c41a;
  position: relative;
  overflow: hidden;
}

.tianyi-download-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #52c41a, #95de64, #52c41a);
  animation: shimmer 2s infinite;
}

.tianyi-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #389e0d;
  font-size: 16px;
}

.tianyi-section-header i {
  font-size: 20px;
  color: #52c41a;
}

.tianyi-download-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.tianyi-download-option {
  height: 48px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  border-color: #52c41a;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  box-shadow: 0 2px 8px rgba(82, 196, 26, 0.3);
}

.tianyi-download-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(82, 196, 26, 0.4);
  background: linear-gradient(135deg, #73d13d 0%, #95de64 100%);
  border-color: #73d13d;
}

.tianyi-option-text {
  flex: 1;
  text-align: center;
  font-weight: 600;
}

.tianyi-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: white;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 0 8px 0 8px;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

.tianyi-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 12px;
  color: #389e0d;
}

.tianyi-tip i {
  font-size: 14px;
}

/* 多文件下载按钮样式 */
.tianyi-download-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
}

.tianyi-multi-file {
  min-width: 120px;
  padding: 10px 12px;
}

.tianyi-file-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: rgba(255,255,255,0.3);
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  margin-right: 6px;
  flex-shrink: 0;
}

.tianyi-multi-file .tianyi-option-text {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* VIP下载区域样式 */
.vip-download-section {
  margin-top: 20px;
  padding: 16px;
  background: linear-gradient(135deg, #fff7e6 0%, #fff2d9 100%);
  border-radius: 12px;
  border: 2px solid #ffd666;
  position: relative;
  overflow: hidden;
}

.vip-download-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffd666, #ffec3d, #ffd666);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.vip-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #d48806;
  font-size: 16px;
}

.vip-section-header i {
  font-size: 20px;
  color: #faad14;
}

.vip-download-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.vip-download-option {
  height: 48px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #faad14 0%, #ffd666 100%);
  border-color: #faad14;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  box-shadow: 0 2px 8px rgba(250, 173, 20, 0.3);
}

.vip-download-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(250, 173, 20, 0.4);
  background: linear-gradient(135deg, #ffc53d 0%, #ffe58f 100%);
  border-color: #ffc53d;
}

.vip-download-option:active {
  transform: translateY(0);
}

.vip-option-text {
  flex: 1;
  text-align: center;
  font-weight: 600;
}

.vip-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #ff7875 0%, #ff4d4f 100%);
  color: white;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 0 8px 0 8px;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  box-shadow: 0 1px 3px rgba(255, 77, 79, 0.3);
}

.vip-download-option i {
  font-size: 16px;
  color: #fff;
}

/* 直连下载列表弹窗样式 */
.direct-download-content {
  max-height: 600px;
  overflow-y: auto;
}

.download-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #dee2e6;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #495057;
  font-weight: 600;
}

.header-info i {
  font-size: 18px;
  color: #007bff;
}

.share-code-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.share-label {
  font-size: 14px;
  color: #6c757d;
}

.share-code {
  background: #007bff;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 14px;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.file-item:hover {
  border-color: #007bff;
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
  transform: translateY(-1px);
}

.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.file-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.file-icon i {
  font-size: 20px;
  color: white;
}

.file-details {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 16px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #6c757d;
}

.file-size {
  font-weight: 600;
  color: #28a745;
}

.file-id {
  color: #6c757d;
}

.file-actions {
  flex-shrink: 0;
}

.download-btn-small {
  height: 36px;
  padding: 0 16px;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.download-btn-small:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,123,255,0.3);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
}

.empty-state i {
  font-size: 64px;
  color: #dee2e6;
  margin-bottom: 16px;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .download-list-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  
  .file-item {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .file-info {
    flex-direction: column;
    gap: 8px;
  }
  
  .file-meta {
    flex-direction: column;
    gap: 4px;
  }
  
  .download-btn-small {
    width: 100%;
  }
}

.site-disclaimer {
  margin-top: 40px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: $radius-md;
  border-left: 4px solid $primary;
  border: $border-lighter;
  border-left: 4px solid $primary;
}

.site-disclaimer h3 {
  color: white;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 600;
}

.site-disclaimer p {
  color: $slate-300;
  line-height: 1.6;
  margin-bottom: 12px;
  font-size: 14px;
}

.site-disclaimer p:last-child {
  margin-bottom: 0;
}

/* ========== 新版下载选项样式 ========== */

/* 网盘下载区域 */
.cloud-download-section {
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 16px;
  background: #f0f9ff;
  border-radius: 12px;
  border: 1px solid #409eff;
}

.cloud-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #409eff;
  font-size: 16px;
}

.cloud-section-header i {
  font-size: 20px;
}

.cloud-download-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.cloud-download-option {
  height: 44px;
  border-radius: 8px;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.cloud-download-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.cloud-option-text {
  flex: 1;
  text-align: center;
}

.cloud-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #67c23a;
  color: white;
  padding: 2px 8px;
  font-size: 10px;
  border-radius: 0 8px 0 8px;
}

/* 锁定选项样式 */
.locked-option {
  opacity: 0.7;
  cursor: not-allowed;
}

.locked-option:hover {
  transform: none;
  box-shadow: none;
}

.tianyi-badge.locked {
  background: linear-gradient(135deg, #e6a23c 0%, #f5c63c 100%);
}

/* 123网盘直连区域样式 */
.pan123-download-section {
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #fff7e6 0%, #fff2d9 100%);
  border-radius: 12px;
  border: 2px solid #faad14;
  position: relative;
  overflow: hidden;
}

.pan123-download-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #faad14, #ffc53d, #faad14);
  animation: shimmer 2s infinite;
}

.pan123-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #d48806;
  font-size: 16px;
}

.pan123-section-header i {
  font-size: 20px;
  color: #faad14;
}

.pan123-download-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.pan123-download-option {
  height: 48px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #faad14 0%, #ffc53d 100%);
  border-color: #faad14;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  box-shadow: 0 2px 8px rgba(250, 173, 20, 0.3);
}

.pan123-download-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(250, 173, 20, 0.4);
  background: linear-gradient(135deg, #ffc53d 0%, #ffd666 100%);
  border-color: #ffc53d;
}

.pan123-option-text {
  flex: 1;
  text-align: center;
  font-weight: 600;
}

.pan123-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: white;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 0 8px 0 8px;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

.pan123-badge.locked {
  background: linear-gradient(135deg, #909399 0%, #c0c4cc 100%);
}

.pan123-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 12px;
  color: #d48806;
}

.pan123-tip i {
  font-size: 14px;
}

/* 无下载选项提示 */
.no-options-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 20px;
  color: #909399;
  font-size: 16px;
  background: #f5f7fa;
  border-radius: 8px;
  margin: 16px 0;
}

.no-options-tip i {
  font-size: 24px;
  color: #e6a23c;
}

/* 多文件天翼下载网格 */
.tianyi-download-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

/* ========== 新版下载弹窗样式 V2 ========== */
.download-dialog-v2 .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.download-dialog-v2 .el-dialog__header {
  padding: 12px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0;
}

.download-dialog-v2 .el-dialog__title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.download-dialog-v2 .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.download-dialog-v2 .el-dialog__body {
  padding: 0;
}

.dl-content {
  padding: 12px;
}

/* 全能卡专属横幅 */
.dl-premium-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #d48806;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
  animation: pulse-banner 2s infinite;
}

.dl-premium-banner i {
  font-size: 14px;
  animation: rotate-star 2s infinite;
}

@keyframes pulse-banner {
  0%, 100% { box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3); }
  50% { box-shadow: 0 4px 12px rgba(255, 215, 0, 0.5); }
}

@keyframes rotate-star {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(10deg); }
}

/* 顶部统计栏 */
.dl-stats-bar {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  gap: 12px;
}

.dl-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 50px;
}

.dl-stat-num {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  line-height: 1.2;
}

.dl-stat-num.is-unlimited {
  color: #67c23a;
  font-size: 14px;
}

.dl-stat-label {
  font-size: 11px;
  color: #909399;
}

.dl-stat-divider {
  width: 1px;
  height: 24px;
  background: #dcdfe6;
}

.dl-stat-tip {
  flex: 1;
  text-align: right;
  font-size: 11px;
  color: #909399;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.dl-stat-tip i {
  font-size: 12px;
}

.dl-moqu-limit-tip {
  margin-top: 10px;
  margin-bottom: 10px;
  color: #e6a23c;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 下载区块 */
.dl-section {
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 6px;
}

.dl-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
}

.dl-section-title i {
  font-size: 13px;
}

.dl-section-title .el-tag {
  margin-left: 2px;
  transform: scale(0.9);
}

/* 天翼直连 */
.dl-tianyi {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border: 2px solid #52c41a;
  box-shadow: 0 2px 8px rgba(82, 196, 26, 0.2);
  position: relative;
}

.dl-tianyi::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #52c41a, transparent);
}

.dl-tianyi .dl-section-title {
  color: #2e7d32;
  font-weight: 700;
}

/* 魔趣直连 */
.dl-moqu-direct {
  background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
  border: 2px solid #fa8c16;
  box-shadow: 0 2px 8px rgba(250, 140, 22, 0.2);
  position: relative;
}

.dl-moqu-direct::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #fa8c16, transparent);
}

.dl-moqu-direct .dl-section-title {
  color: #d46b08;
  font-weight: 700;
}

/* 版本分组样式 */
.dl-version-group {
  margin-bottom: 8px;
}

.dl-version-group:last-child {
  margin-bottom: 0;
}

.dl-version-title {
  font-size: 11px;
  color: #d46b08;
  margin-bottom: 6px;
  padding-left: 4px;
  border-left: 2px solid #fa8c16;
}

/* 专属直连 */
.dl-pan123 {
  background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
  border: 2px solid #faad14;
  box-shadow: 0 2px 8px rgba(250, 173, 20, 0.2);
  position: relative;
}

.dl-pan123::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #faad14, transparent);
}

.dl-pan123 .dl-section-title {
  color: #d48806;
  font-weight: 700;
}

/* 网盘下载 */
.dl-cloud {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border: 1px solid #64b5f6;
}

.dl-cloud .dl-section-title {
  color: #1565c0;
}

/* 按钮列表 */
.dl-btn-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.dl-btn-list.dl-btn-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.dl-btn-list.dl-btn-row .dl-btn {
  width: 100%;
}

.dl-btn.el-button {
  position: relative;
  height: 28px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  line-height: 26px;
  width: 100%;
  margin: 0;
}

.dl-btn.is-locked {
  opacity: 0.6;
}

.dl-btn-tag {
  position: absolute;
  top: -1px;
  right: -1px;
  background: #67c23a;
  color: #fff;
  font-size: 9px;
  padding: 1px 4px;
  border-radius: 0 4px 0 4px;
  line-height: 1;
}

/* 空状态 */
.dl-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 30px;
  color: #909399;
  font-size: 14px;
  background: #f5f7fa;
  border-radius: 8px;
}

.dl-empty i {
  font-size: 20px;
  color: #e6a23c;
}

/* 无网盘提示 - 更轻量的样式 */
.dl-empty-cloud {
  padding: 12px 16px;
  background: #f0f9ff;
  border: 1px dashed #91d5ff;
}

.dl-empty-cloud i {
  color: #1890ff;
  font-size: 16px;
}

/* 密码区域 */
.dl-password {
  background: #fafafa;
  border-radius: 6px;
  padding: 8px 12px;
  margin-top: 8px;
}

.dl-pwd-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 12px;
}

.dl-pwd-label {
  color: #909399;
}

.dl-pwd-value {
  background: #fff;
  border: 1px solid #e4e7ed;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: monospace;
  color: #e6a23c;
  cursor: pointer;
  transition: all 0.2s;
}

.dl-pwd-value:hover {
  background: #fdf6ec;
  border-color: #e6a23c;
}

/* 申请直连区域 */
.dl-request-section {
  margin-top: 12px;
  padding: 10px;
  background: #f0f9ff;
  border-radius: 6px;
  border-left: 3px solid #67c23a;
}

.dl-request-btn {
  width: 100%;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  background: #67c23a;
  border: none;
  color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(103, 194, 58, 0.2);
}

.dl-request-btn:hover {
  background: #85ce61;
  box-shadow: 0 4px 8px rgba(103, 194, 58, 0.3);
  transform: translateY(-1px);
}

.dl-request-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(103, 194, 58, 0.2);
}

.dl-request-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.dl-request-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(250, 173, 20, 0.3);
}

.dl-request-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.dl-request-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #606266;
  margin-top: 8px;
  padding: 6px 0;
}

.dl-request-tip i {
  font-size: 13px;
  color: #67c23a;
}

/* 无资源状态 */
.dl-no-resource {
  padding: 20px;
  text-align: center;
}

.dl-empty-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  background: #f4f4f5;
  border-radius: 8px;
  margin-bottom: 16px;
}

.dl-empty-box i {
  font-size: 36px;
  color: #909399;
}

.dl-empty-text h4 {
  margin: 0 0 4px 0;
  color: #606266;
  font-size: 16px;
}

.dl-empty-text p {
  margin: 0;
  color: #909399;
  font-size: 13px;
}

.dl-request-btn-large {
  width: 100%;
  height: 44px;
  font-size: 15px;
  border-radius: 8px;
  background: #67c23a;
  border-color: #67c23a;
}

.dl-request-btn-large:hover {
  background: #85ce61;
  border-color: #85ce61;
}

.dl-request-tip-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
  color: #909399;
  font-size: 12px;
}

.dl-request-tip-center i {
  color: #67c23a;
}

/* 无权限状态 */
.dl-no-permission {
  padding: 20px;
  text-align: center;
}

.dl-vip-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  background: #fdf6ec;
  border-radius: 8px;
  margin-bottom: 16px;
}

.dl-vip-box i {
  font-size: 36px;
  color: #e6a23c;
}

.dl-vip-text h4 {
  margin: 0 0 4px 0;
  color: #e6a23c;
  font-size: 16px;
}

.dl-vip-text p {
  margin: 0;
  color: #909399;
  font-size: 13px;
}

.dl-upgrade-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  border-radius: 8px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .download-dialog-v2 .el-dialog {
    width: 92% !important;
    margin: 0 auto;
  }
  
  .dl-stats-bar {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .dl-stat-tip {
    width: 100%;
    justify-content: center;
    margin-top: 4px;
  }

  .dl-moqu-limit-tip {
    justify-content: center;
    font-size: 12px;
  }
  
  .dl-btn-list {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .dl-pwd-row {
    justify-content: center;
  }
}

/* ========== 深色主题弹窗样式 ========== */
:deep(.download-dialog-v2) {
  .el-dialog {
    background: $card;
    border: $border-light;
    border-radius: $radius-xl;
    box-shadow: $shadow-lg;
  }

  .el-dialog__header {
    background: $gradient-primary;
    padding: 20px 24px;
    border-radius: $radius-xl $radius-xl 0 0;
    border-bottom: none;
  }

  .el-dialog__title {
    color: white;
    font-size: 18px;
    font-weight: 700;
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 24px;

    .el-dialog__close {
      color: white;
      font-size: 20px;
      font-weight: 700;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
    background: $card;
  }
}

.dl-content {
  color: $slate-300;
}

/* 统计栏 - 深色主题 */
.dl-stats-bar {
  background: rgba(255, 255, 255, 0.05);
  border: $border-lighter;
  border-radius: $radius-md;
  padding: 16px;
  margin-bottom: 20px;
}

.dl-stat-num {
  color: white;
  font-size: 20px;
  font-weight: 700;
}

.dl-stat-num.is-unlimited {
  color: #67c23a;
}

.dl-stat-label {
  color: $slate-400;
  font-size: 12px;
}

.dl-stat-divider {
  background: rgba(255, 255, 255, 0.1);
}

.dl-stat-tip {
  color: $slate-400;
}

.dl-moqu-limit-tip {
  color: #fbbf24;
}

/* 全能卡横幅 - 深色主题 */
.dl-premium-banner {
  background: linear-gradient(135deg, rgba(251, 191, 36, 0.2) 0%, rgba(245, 158, 11, 0.2) 100%);
  border: 2px solid rgba(251, 191, 36, 0.5);
  color: #fbbf24;
  padding: 12px 16px;
  border-radius: $radius-md;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  animation: pulse-banner 2s infinite;

  i {
    font-size: 16px;
    animation: rotate-star 2s infinite;
  }
}

/* 下载区块 - 深色主题 */
.dl-section {
  margin-bottom: 16px;
  padding: 16px;
  border-radius: $radius-md;
  border: 2px solid;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    animation: shimmer 2s infinite;
  }
}

.dl-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
  color: white;

  i {
    font-size: 16px;
  }

  :deep(.el-tag) {
    border: none;
    font-weight: 600;
  }
}

/* 天翼直连 - 深色主题 */
.dl-tianyi {
  background: linear-gradient(135deg, rgba(82, 196, 26, 0.15) 0%, rgba(103, 194, 58, 0.1) 100%);
  border-color: rgba(82, 196, 26, 0.5);

  &::before {
    background: linear-gradient(90deg, transparent, #52c41a, transparent);
  }

  .dl-section-title {
    color: #67c23a;
  }
}

/* 魔趣直连 - 深色主题 */
.dl-moqu-direct {
  background: linear-gradient(135deg, rgba(250, 140, 22, 0.15) 0%, rgba(251, 191, 36, 0.1) 100%);
  border-color: rgba(250, 140, 22, 0.5);

  &::before {
    background: linear-gradient(90deg, transparent, #fa8c16, transparent);
  }

  .dl-section-title {
    color: #fbbf24;
  }
}

.dl-version-title {
  font-size: 12px;
  color: #fbbf24;
  margin-bottom: 8px;
  padding-left: 8px;
  border-left: 3px solid #fa8c16;
}

/* 网盘下载 - 深色主题 */
.dl-cloud {
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.15) 0%, rgba(100, 181, 246, 0.1) 100%);
  border-color: rgba(64, 158, 255, 0.5);

  .dl-section-title {
    color: #409eff;
  }
}

/* 按钮列表 */
.dl-btn-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  &.dl-btn-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

.dl-btn {
  position: relative;
  height: 40px;
  border-radius: $radius-md;
  font-size: 13px;
  font-weight: 600;
  transition: $transition-normal;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: $shadow-md;
  }

  &.is-locked {
    opacity: 0.5;
    cursor: not-allowed;
  }

  :deep(.el-button) {
    width: 100%;
    height: 100%;
  }
}

.dl-btn-tag {
  position: absolute;
  top: -1px;
  right: -1px;
  background: #67c23a;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 0 $radius-md 0 $radius-md;
  line-height: 1;
  font-weight: 700;
}

/* 密码区域 - 深色主题 */
.dl-password {
  background: rgba(255, 255, 255, 0.05);
  border: $border-lighter;
  border-radius: $radius-md;
  padding: 16px;
  margin-top: 16px;
}

.dl-pwd-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 13px;
}

.dl-pwd-label {
  color: $slate-400;
  font-weight: 500;
}

.dl-pwd-value {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 6px 12px;
  border-radius: $radius-sm;
  font-family: 'Courier New', monospace;
  color: #fbbf24;
  cursor: pointer;
  transition: $transition-normal;
  font-weight: 600;

  &:hover {
    background: rgba(251, 191, 36, 0.15);
    border-color: rgba(251, 191, 36, 0.5);
    transform: translateY(-1px);
  }
}

/* 空状态 - 深色主题 */
.dl-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  color: $slate-400;
  font-size: 15px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: $radius-md;
  border: 1px dashed rgba(255, 255, 255, 0.1);

  i {
    font-size: 24px;
    color: $slate-500;
  }
}

.dl-empty-cloud {
  padding: 16px;
  background: rgba(64, 158, 255, 0.05);
  border-color: rgba(64, 158, 255, 0.2);

  i {
    color: #409eff;
  }
}

/* 无资源/无权限状态 - 深色主题 */
.dl-no-resource,
.dl-no-permission {
  padding: 32px 24px;
  text-align: center;
}

.dl-empty-box,
.dl-vip-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: $radius-md;
  margin-bottom: 20px;
  border: $border-lighter;

  i {
    font-size: 40px;
  }
}

.dl-empty-box i {
  color: $slate-500;
}

.dl-vip-box {
  background: rgba(251, 191, 36, 0.1);
  border-color: rgba(251, 191, 36, 0.3);

  i {
    color: #fbbf24;
  }
}

.dl-empty-text,
.dl-vip-text {
  text-align: left;

  h4 {
    margin: 0 0 8px 0;
    color: white;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: $slate-400;
    font-size: 14px;
  }
}

.dl-vip-text h4 {
  color: #fbbf24;
}

.dl-upgrade-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: $radius-xl;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  border: none;
  color: white;
  font-weight: 700;
  cursor: pointer;
  transition: $transition-normal;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(251, 191, 36, 0.4);
    opacity: 0.95;
  }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes pulse-banner {
  0%, 100% { box-shadow: 0 2px 8px rgba(251, 191, 36, 0.3); }
  50% { box-shadow: 0 4px 16px rgba(251, 191, 36, 0.5); }
}

@keyframes rotate-star {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(10deg); }
}
</style>
